<template lang='pug'>
  div(v-if='savingStatus').mr-2
    span(v-if="savingStatus === 'SAVING'") Saving...
    span(v-if="savingStatus === 'SAVED'") Saved
</template>

<script>
export default {
  name: 'BionicMetricsSaving',
  props: {
    savingStatus: {
      type: String
    }
  }
};
</script>

<style scoped>
</style>
